import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import CustomInput from '../../../../components/common/Input/input';
import SettingsBreadcrumb from '../../../../components/SettingsBreadcrumb';
import './inserir-rede-social.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  faFacebookSquare, faInstagram, faLinkedin, faYoutube,
  faTiktok, faXTwitter, faWhatsapp, faTelegram, faTumblrSquare
} from '@fortawesome/free-brands-svg-icons';
import {
  Flex,
  Heading,
  Box,
  Button,
  FormLabel,
  FormControl,
  Select,
  Stack,
  Checkbox,
  Radio,
  RadioGroup,
  FormHelperText,
  IconButton,
  Tooltip,
} from '@chakra-ui/react';
import { FileWithPath } from 'react-dropzone';
import * as api from '../../../../api/redesSociais';
import Swal from 'sweetalert2';
import { listarCategoriasAtivas } from '../../../../api/categoria';
import { listarExecutores } from '../../../../api/noticia';
import { obterUsuario } from '../../../../api/usuario';
import { AudioVideoImageDropzone } from '../../../../components/common/audioVideoImageDropzone/audio-video-image-dropzone';
import CustomTextArea from '../../../../components/common/Textarea/textArea';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PublicacaoParams } from '../../../../interfaces/publicacao.interface';
import { MdInfoOutline } from 'react-icons/md';
import { listarSecretariasAtivas } from '../../../../api/secretarias';

const InserirRedeSocial: React.FC = () => {
  const navigate = useNavigate();
  const today = new Date().toISOString().split('T')[0];
  const { id } = useParams();

  const [formValues, setFormValues] = useState<{
    titulo: { value: string; error: boolean };
    data: { value: typeof today; error: boolean };
    imagem: { value: string; error: boolean };
    links: { value: string; error: boolean };
    localizacao: { value: string; error: boolean };
    mensagem: { value: string; error: boolean };
    categoriaId: { value: string; error: boolean };
    redeId: { value: any[]; error: boolean };
    secretariaId: { value: any[]; error: boolean };
    usuarioId: { value: any; error: boolean };
    exigeAprovacao: { value: number; error: boolean };
  }>({
    titulo: { value: '', error: false },
    data: { value: today, error: false },
    imagem: { value: '', error: false },
    links: { value: '', error: false },
    localizacao: { value: '', error: false },
    mensagem: { value: '', error: false },
    categoriaId: { value: '', error: false },
    redeId: { value: [], error: false },
    secretariaId: { value: [], error: false },
    usuarioId: { value: null, error: false },
    exigeAprovacao: { value: 0, error: false },
  });

  const [imageVideoBase64, setImageVideoBase64] = useState<string>('');
  const [categorias, setCategorias] = useState<any[]>([]);
  const [redes, setRedes] = useState<any[]>([]);
  const [secretarias, setSecretarias] = useState<any[]>([]);
  const [secretariaSelecionada, setSecretariaSelecionada] = useState<number[]>([]);
  const [aprovadores, setAprovadores] = useState<any[]>([]);
  const [seqUsuario, setSeqUsuario] = useState<any[]>([]);
  const [nomeUsuarioLogado, setNomeUsuarioLogado] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedPages, setSelectedPages] = useState<number[]>([]);
  const [selectedUser, setSelectedUser] = useState<number | null>(null);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [tamanhoPagina, setTamanhoPagina] = useState(10);
  const [idUrl, setIdUrl] = useState<string | null>(null);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [arquivo, setArquivo] = useState<any>();
  const [arquivoSelecionado, setArquivoSelecionado] = useState<File | null>(null);

  useEffect(() => {
    const urlAtual = window.location.hash;
    const partesUrl = urlAtual.split('/');
    const idDaUrl = partesUrl[partesUrl.length - 2];

    setIdUrl(idDaUrl);
  }, []);

  useEffect(() => {
    if (idUrl) {
      const fetchRedeSocial = async () => {
        setLoading(true);
        try {
          const data = await api.listarContasRedesSociais(paginaAtual, tamanhoPagina, Number(idUrl));

          if (data.conteudo && data.conteudo.length > 0) {
            setRedes(data.conteudo.map((categoria: any) => ({
              seqConfigRede: categoria.seqConfigRede,
              dscUsuario: categoria.dscUsuario,
              datRegistro: categoria.datRegistro,
              sitRegistro: categoria.sitRegistro,
            })));
          } else {
            setRedes([]);
          }
        } catch (error) {
          console.error('Erro ao buscar contas em redes sociais:', error);
        } finally {
          setLoading(false);
        }
      };

      fetchRedeSocial();
    }
  }, [idUrl, paginaAtual, tamanhoPagina]);

  useEffect(() => {
    const storedUsuario = localStorage.getItem('dadosUsuario');
    if (storedUsuario) {
      try {
        const usuario = JSON.parse(storedUsuario);
        setSeqUsuario(usuario.seqUsuario);
        
        const fetchObterUsuario = async () => {
          try {
           const [data, ativas] = await Promise.all([
             obterUsuario(Number(usuario.seqUsuario)),
             listarSecretariasAtivas()
           ]);
           setSecretarias(
            data.usuarioSecretariaDTO?.length ? data.usuarioSecretariaDTO : ativas
          );
          } catch (error) {
            console.error("Erro ao obter usuario:", error);
          }
        };
  
        fetchObterUsuario();
  
      } catch (error) {
        console.error("Erro ao recuperar os dados do usuário:", error);
      }
    }

    const fetchCategorias = async () => {
      try {
        const data = await listarCategoriasAtivas();
        setCategorias(data);
      } catch (error) {
        console.error('Erro ao buscar categorias ativas:', error);
      }
    };

    fetchCategorias();
    fetchAprovadoresAtivos();
  }, []);

  useEffect(() => {
    const fetchRedeSocial = async () => {
      setLoading(true);
      try {
        const data = await api.listarRedesSociais(paginaAtual, tamanhoPagina);
        setRedes(data.formatoArquivos || []);
      } catch (error) {
        console.error('Erro ao buscar ícones de redes sociais:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchRedeSocial();
  }, []);

  const fetchAprovadoresAtivos = async () => {
    try {
      const data = await listarExecutores();
      setAprovadores(data);
    } catch (error) {
      console.error('Erro ao buscar lista de executores para aprovação:', error);
    }
  };

  const handleFieldChange = (field: keyof typeof formValues, value: any) => {
    setFormValues({ ...formValues, [field]: { value, error: false } });
  };

  const handleCheckboxSecretaria = (codSecretaria: number, checked: boolean) => {
    setSecretariaSelecionada(prev =>
      checked ? Array.from(new Set([...prev, codSecretaria])) : prev.filter(id => id !== codSecretaria)
    );
  
    setFormValues(prev => {
      const current: number[] = Array.isArray(prev?.secretariaId?.value) ? prev.secretariaId.value : [];
      const next = checked
        ? Array.from(new Set([...current, codSecretaria]))
        : current.filter(id => id !== codSecretaria);
  
      return {
        ...prev,
        secretariaId: { ...prev.secretariaId, value: next, error: prev?.secretariaId?.error ?? false },
      };
    });
  };  

  const handleCheckboxChange = (seqConfigRede: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;

    setSelectedPages((prev) => {
      const updatedPages = isChecked
        ? [...prev, seqConfigRede]
        : prev.filter((id) => id !== seqConfigRede);
      return updatedPages;
    });

    setFormValues((prevValues: any) => {
      const updatedredeIdValue = isChecked
        ? [...(prevValues.redeId?.value || []), seqConfigRede]
        : (prevValues.redeId?.value || []).filter((id: number) => id !== seqConfigRede);

      let updatedOrdemValue = [...(prevValues.ordemBanner?.value || [])];
      if (isChecked) {
        updatedOrdemValue.push({ seqConfigRede, numOrdem: '' });
      } else {
        updatedOrdemValue = updatedOrdemValue.filter(
          (redeOrdem: any) => redeOrdem.seqConfigRede !== seqConfigRede
        );
      }

      return {
        ...prevValues,
        redeId: { value: updatedredeIdValue },
        ordemBanner: { value: updatedOrdemValue },
      };
    });
  };

  const handleRadioChange = (seqUsuario: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;

    setSelectedUser(isChecked ? seqUsuario : null);

    setFormValues((prevValues: any) => {
      const updatedUsuarioIdValue = isChecked ? seqUsuario : null;

      return {
        ...prevValues,
        usuarioId: { value: updatedUsuarioIdValue },
      };
    });
  };

  const handleInputRadioChange = (field: string, value: any) => {
    if (field === 'exigeAprovacao' && value === 0) {
      setFormValues({
        ...formValues,
        [field]: { error: false, value },
        usuarioId: { value: null, error: false }
      });
    } else {
      setFormValues({
        ...formValues,
        [field]: { error: false, value }
      });
    }
  };

  const handleImageSelected = async (selected: FileWithPath | null) => {
    if (selected) {
      const isImage = selected.type.startsWith("image/");
      const isVideo = selected.type.startsWith("video/");
      const isAudio = selected.type.startsWith("audio/");

      // Para TikTok (idUrl = 4), aceita apenas vídeos
      if (Number(idUrl) === 4 && !isVideo) {
        Swal.fire({
          icon: 'error',
          title: 'Arquivo inválido',
          text: 'TikTok aceita apenas vídeos. Por favor, selecione um arquivo de vídeo.'
        });
        setArquivo(null);
        setArquivoSelecionado(null);
        return;
      }

      setArquivo(selected);

      if (isImage || isVideo || isAudio) {
        setArquivoSelecionado(selected);
        setArquivo(selected);

      } else {
        console.error("Tipo de arquivo não suportado.");
      }
    } else {
      setArquivo(null);
      setArquivoSelecionado(null);
      console.warn("Nenhum arquivo selecionado.");
    }
  };

  const tituloRede = (codigo: number) => {
    const titles: { [key: number]: string } = {
      0: 'Facebook',
      1: 'Instagram',
      2: 'LinkedIn',
      3: 'Youtube',
      4: 'TikTok',
      5: 'X (Antigo Twitter)',
      6: 'Whatsapp',
      7: 'Telegram',
      8: 'Tumblr',
      9: 'Página Internet',
    };

    return titles[codigo] || '';
  };

  const iconeRedeSocial = (id: number) => {
    const icones: { [key: number]: { icon: any, color: string } } = {
      0: { icon: faFacebookSquare, color: "#1789fc" },
      1: { icon: faInstagram, color: "#ec1393" },
      2: { icon: faLinkedin, color: "#1DA1F2" },
      3: { icon: faYoutube, color: "#ff0000" },
      4: { icon: faTiktok, color: "#080404" },
      5: { icon: faXTwitter, color: "#080404" },
      6: { icon: faWhatsapp, color: "#43e460" },
      7: { icon: faTelegram, color: "#088ccc" },
      8: { icon: faTumblrSquare, color: "#384c5c" },
    };

    return icones[id] || { icon: faGlobe, color: "#3b87d8" };
  };

  function getMaxLength(id: number) {
    switch (Number(idUrl)) {
      case 0: return 63206;
      case 1: return 2200;
      case 2: return 3000;
      case 3: return 5000;
      case 4: return 2200;
      case 5: return 280;
      case 6: return 65536;
      case 7: return 4096;
      case 8: return 4096;
      default: return 200;
    }
  }

  function isImagemVideoObrigatorio(id: number) {
    switch (id) {
      case 4:
      case 3:
      case 1:
        return true;
      default:
        return false;
    }
  }

  const isFormValid = () => {
    const { titulo, data, categoriaId, redeId, usuarioId, exigeAprovacao } = formValues;

    if (exigeAprovacao.value == 1) {
      if (!usuarioId.value || usuarioId.value == null) {
        return false;
      }
    }

    const isValid = (
      titulo.value &&
      data.value &&
      categoriaId.value &&
      redeId.value.length > 0 &&
      (isImagemVideoObrigatorio(Number(idUrl)) ? arquivoSelecionado !== null : true) &&
      (exigeAprovacao.value == 0 || (exigeAprovacao.value == 1 && usuarioId.value != null))
    );
    return isValid;
  }

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    setLoadingSubmit(true);

    const { links, localizacao, categoriaId, redeId, secretariaId, usuarioId, mensagem, data } = formValues;

    const pendencia = usuarioId.value
      ? {
        codPendencia: 1,
        seqSolicitante: seqUsuario,
        seqExecutor: usuarioId.value,
      }
      : null;

      let codSituacao = 1;
  
    if (data.value) {
      const dataDaPublicacao = data.value;
      const diaDeHoje = new Date().toISOString().split("T")[0];

      if (pendencia) {
        codSituacao = 5;
      } else if (dataDaPublicacao > diaDeHoje) {
        codSituacao = 1;
      } else if (dataDaPublicacao === diaDeHoje) {
        codSituacao = 2;
      }  
    } else {
      codSituacao = 2;
    }

    const params: PublicacaoParams = {
      codTipoPublicacao: 6,
      nomePublicacao: formValues.titulo.value || null,
      dscResumo: null,
      codSituacaoPubli: codSituacao,
      datPublicacao: formValues.data.value ? formValues.data.value : null,
      seqUsuario: seqUsuario,
      dscUsuarios: nomeUsuarioLogado,
      dscCitacaoUsuario: null,
      dscTags: null,
      binPublicacao: null,
      urlBin: null,
      dscPublicacao: mensagem.value || null,
      dscEnderecoEvento: null,
      seqCategoria: Number(categoriaId.value) || null,
      contasRedeSocial: redeId.value.map((id: number) => {
        return {
          seqConfigRede: id,
        };
      }),
      pendencia: pendencia,
      numAprovacao: pendencia ? 1 : 0,
      numAprovado: 0,
      datInicioEvento: null,
      datFimEvento: null,
      dscHoraInicioEvento: null,
      dscHoraFimEvento: null,
      datDespublicar: null,
      numRegistro: 1,
      dscCreditoImagem: null,
      dscCreditoNoticia: null,
      conteudoPaginaDTO: [],
      conteudoSecretariaDTO: secretariaId.value.map((id: number) => ({
        codSecretaria: id,
      })),
    };

    try {
      if (arquivoSelecionado) {
        const formData = new FormData();
        formData.append("file", arquivo);

        const fileType = arquivoSelecionado.type.split("/")[1];

        let fileNameToSend = 'redeSocial';
        if (fileType) {
          fileNameToSend = `${fileNameToSend}.${fileType}`;
        }

        const nomePasta = 'publicacoes';

        formData.append("fileName", fileNameToSend);
        formData.append("folderName", nomePasta);

        const cdnData = await api.inserirRedeSocialNoCdn(formData);

        let cdnUrl = "";
        if (typeof cdnData === "string") {
          const regex = /(https?:\/\/[^\s]+)/g;
          const match = cdnData.match(regex);
          if (match && match[0]) {
            cdnUrl = match[0];
          } else {
            throw new Error("URL não encontrada na resposta do CDN.");
          }
        } else if (cdnData && cdnData.url) {
          cdnUrl = cdnData.url;
        } else {
          throw new Error("Resposta do CDN inesperada.");
        }

        params.binPublicacao = cdnUrl;
      }

      await api.criarPublicacao(params);
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: 'Publicação criada com sucesso.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/publicacao/redes-sociais');
      });
    } catch (error) {
      console.error('Erro ao inserir publicação:', error);
      Swal.fire({
        icon: 'error',
        title: 'Ocorreu um erro!',
        text: 'Não foi possível inserir a publicação. Por favor, verifique se as configurações da conta de publicação estão corretas e tente novamente.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/publicacao/redes-sociais');
      });
    } finally {
      setLoadingSubmit(false);
    }

  };

  return (
    <Flex
      direction="column"
      padding='40px'
      background-color='#fafafa'
      width='100%'
      height={formValues.exigeAprovacao.value === 1 ? '100%' : '100%'}
      overflow='hidden'
    >
      <SettingsBreadcrumb />
      <Heading display={'flex'} alignItems={'center'} mt="30px" fontWeight="600" fontSize="21px" color="#6F6F6F" w="100%">
        Inserir Publicação
      </Heading>
      <Heading display={'flex'} alignItems={'center'} mt="20px" fontWeight="500" fontSize="20px" color="#3b3b3b" w="100%">
        <FontAwesomeIcon
          style={{ marginRight: '10px', fontSize: '25px' }}
          icon={iconeRedeSocial(Number(idUrl)).icon}
          color={iconeRedeSocial(Number(idUrl)).color}
        />
        {`${tituloRede(Number(idUrl))}`}
      </Heading>
      <Box m="40px 0" w="100%">
        <form onSubmit={handleFormSubmit}>
          <div className="row">
            <div className="col-md-6 mb-4">
              <FormControl isRequired isInvalid={formValues.categoriaId.error}>
                <FormLabel mb="8px">Categoria da Publicação</FormLabel>
                <Select
                  placeholder='Selecione uma Categoria'
                  borderColor="gray.300"
                  _hover={{ borderColor: 'blue.500' }}
                  value={formValues.categoriaId.value}
                  onChange={(e) => handleFieldChange('categoriaId', e.target.value)}
                >
                  {categorias.length > 0 ? (
                    categorias.map(categoria => (
                      <option key={categoria.seqCategoria} value={categoria.seqCategoria}>
                        {categoria.dscCategoria}
                      </option>
                    ))
                  ) : (
                    ''
                  )}
                </Select>
              </FormControl>
            </div>
            <div className="col-md-6 mb-4">
              <FormControl isRequired isInvalid={formValues.titulo.error}>
                <FormLabel mb="8px">Título da Publicação</FormLabel>
                <CustomInput
                  value={formValues.titulo.value}
                  onChange={(e: any) => handleFieldChange('titulo', e.target.value)}
                  placeholder="Digite um título"
                  maxLength={100}
                />
              </FormControl>
            </div>

            <div className="col-md-6 mb-4">
              <FormControl isInvalid={formValues.mensagem.error}>
              <FormLabel mb="8px">
                Mensagem/Descrição
                <span style={{ marginLeft: '5px', color: 'red' }}>*</span>
                <Tooltip
                  label="Insira hashtags (ex.: #exemplo) e links (ex.: https://www.exemplo.com), que serão automaticamente formatados para a publicação."
                  aria-label="Informação sobre a mensagem/Descrição"
                >
                  <IconButton
                    className="icones"
                    icon={<MdInfoOutline />}
                    variant="link"
                    aria-label="Informação"
                    size="md"
                    color="#2883de"
                  />
                </Tooltip>
              </FormLabel>
                <CustomTextArea
                  style={{ resize: 'none' }}
                  value={formValues.mensagem.value}
                  onChange={(e: any) => handleFieldChange('mensagem', e.target.value)}
                  placeholder="Digite uma mensagem ou descrição"
                  height={'145px'}
                  maxLength={getMaxLength(Number(idUrl))}
                />
                <FormHelperText>
                  Máximo de caracteres: {getMaxLength(Number(idUrl))}
                </FormHelperText>
              </FormControl>
            </div>

            <div className="col-md-6 mb-4">
              <FormControl isRequired={isImagemVideoObrigatorio(Number(idUrl))}>
                <FormLabel mb="8px">Mídia</FormLabel>
                <AudioVideoImageDropzone
                  onImageSelected={handleImageSelected}
                  base64={imageVideoBase64}
                  uploadMessage={`Arraste a imagem ou vídeo da publicação aqui ou clique para selecionar.`}
                  width={600}
                  height={138}
                />
              </FormControl>
            </div>

            <div className="col-md-3 mb-4">
              <Flex direction="row" justify="space-between" align="flex-start">
                <FormControl>
                  <Flex justify="space-between" align="center" mb="8px">
                    <FormLabel mb="8px">
                      Escolha em quais contas deseja publicar
                      <span style={{ marginLeft: '5px', color: 'red' }}>*</span>
                    </FormLabel>
                  </Flex>

                  <div className="sidebar-checkbox-pagina">
                    <Stack spacing={5}>
                      {redes.length > 0 ? (
                        redes.map((rede) => {
                          const inputRef = React.createRef<HTMLInputElement>();
                          return (
                            <Flex key={rede.seqConfigRede} align="center" justify="space-between" direction={{ base: 'column', md: 'row' }}>
                              <Checkbox
                                className="checkredes"
                                isChecked={selectedPages.includes(rede.seqConfigRede)}
                                onChange={(e) => handleCheckboxChange(rede.seqConfigRede, e)}
                              >
                                {rede.dscUsuario}
                              </Checkbox>
                            </Flex>
                          );
                        })
                      ) : (
                        <p>Não há contas cadastradas.</p>
                      )}
                    </Stack>
                  </div>
                </FormControl>
              </Flex>
            </div>

            <div className="col-md-3 mb-4">
              <FormControl isRequired>
                <FormLabel mb="8px">Data para Publicação</FormLabel>
                <CustomInput
                  id="social-media-insert-publication-date"
                  type="date"
                  value={formValues.data.value}
                  onChange={(e) => handleFieldChange('data', e.target.value)}
                  min={today}
                />
              </FormControl>
            </div>

            <div className="col-md-6 mb-4">
            <div className="row">
              <FormControl className="mb-4">
                {secretarias.length > 0 && (
                  <>
                    <Flex justify="space-between" align="center">
                      <FormLabel mb="8px">
                        Associe o usuário a uma secretaria (opcional)
                      </FormLabel>
                    </Flex>

                    <Box
                      border="1px solid"
                      borderColor="gray.300"
                      borderRadius="md"
                      p={3}
                    >
                      <Box overflow="hidden">
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                          <colgroup>
                            <col style={{ width: '60px' }} />
                            <col style={{ width: '120px' }} />
                            <col />
                          </colgroup>
                          <thead>
                            <tr>
                              <th style={{ textAlign:'center', padding:'8px', borderBottom:'1px solid #ddd' }}></th>
                              <th style={{ textAlign:'left',   padding:'8px', borderBottom:'1px solid #ddd', color:'gray' }}>Código</th>
                              <th style={{ textAlign:'left',   padding:'8px', borderBottom:'1px solid #ddd', color:'gray' }}>Secretaria</th>
                            </tr>
                          </thead>
                        </table>
                      </Box>

                      <Box 
                        className="sidebar-checkbox-pagina"
                        overflowX="auto"
                        overflowY={secretarias.length > 5 ? 'auto' : 'visible'}
                        maxH={secretarias.length > 5 ? '240px' : 'unset'}
                      >
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                          <colgroup>
                            <col style={{ width: '60px' }} />
                            <col style={{ width: '120px' }} />
                            <col />
                          </colgroup>
                          <tbody>
                          {secretarias.map((secretaria: any) => {
                          const cod = Number(secretaria.codSecretaria);
                          const nome = secretaria.secretariasDTO?.dscSecretaria ?? secretaria.dscSecretaria ?? '—';

                          return (
                            <tr key={cod}>
                              <td style={{ textAlign: "center", padding: "8px", borderBottom: "1px solid #ddd" }}>
                                <Checkbox
                                  className="checkCategorias"
                                  isChecked={secretariaSelecionada.includes(cod)}
                                  onChange={(e) => handleCheckboxSecretaria(cod, e.target.checked)}
                                />
                              </td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{cod}</td>
                              <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{nome}</td>
                            </tr>
                          );
                        })}
                        </tbody>
                        </table>
                      </Box>
                    </Box>
                  </>
                )}
              </FormControl>
                <div className={`mb-4 col-md-${formValues.exigeAprovacao.value === 1 ? '4' : '6'}`}>
                  <FormControl isRequired>
                    <FormLabel mb="8px">Exige aprovação</FormLabel>
                    <RadioGroup
                      mt={3.5}
                      onChange={(value) => handleInputRadioChange('exigeAprovacao', Number(value))}
                      value={formValues.exigeAprovacao.value.toString()}
                    >
                      <Radio value="1" mr={5}>Sim</Radio>
                      <Radio value="0">Não</Radio>
                    </RadioGroup>
                  </FormControl>
                </div>

                {formValues.exigeAprovacao.value === 1 && (
                  <div className="col-md-8 mb-4">
                    <FormControl isRequired>
                      <FormLabel mb="8px">Selecione o aprovador desta publicação</FormLabel>
                      <div className={`input-radio-lista ${aprovadores.length === 0 ? 'escondida' : ''}`}>
                        <Stack spacing={5}>
                          {aprovadores.length > 0 ? (
                            aprovadores.map((aprovador: any) => (
                              <Flex key={aprovador.seqUsuario} align="center" justify="space-between" direction="row">
                                <Radio
                                  className="radioAprovadoresNoticia"
                                  value={aprovador.seqUsuario.toString()}
                                  isChecked={selectedUser === aprovador.seqUsuario}
                                  onChange={(e) => handleRadioChange(aprovador.seqUsuario, e)}

                                >
                                  {aprovador.dscNome}
                                </Radio>
                              </Flex>
                            ))
                          ) : (
                            <p>Não há lista de aprovadores disponíveis.</p>
                          )}
                        </Stack>
                      </div>
                    </FormControl>
                  </div>
                )}
              </div>
            </div>
          </div>

          <Flex justifyContent="end">
            <Button
              m="6px"
              onClick={() => navigate(-1)}
            >
              Desistir
            </Button>
            <Button
              type="submit"
              m="6px"
              color="#FFF"
              bgColor="#1665D8"
              isLoading={loadingSubmit}
              _hover={{ opacity: 0.8 }}
              loadingText="Inserindo Rede Social..."
              isDisabled={!isFormValid() || loadingSubmit}
            >
              {formValues.exigeAprovacao.value === 1
                ? 'Enviar para Aprovação'
                : 'Criar Publicação'}
            </Button>
          </Flex>
        </form>
      </Box>
    </Flex>
  );
};

export default InserirRedeSocial;
